"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padNumberStart = padNumberStart;
/** Pads the value with a given string to a given length from the start (left). */
function padNumberStart(value, digits, fillString) {
  return String(value).padStart(digits, fillString);
}
